export default __webpack_public_path__ + "static/Endosos-2383f232f39b4f367a5064c1c207eddb.png";